import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "DropboxModule"
const debug = false

export class DropboxModule extends ModuleProto {

    constructor() {
        super(ModuleType.DROPBOX, {});

        debug && console.log(debug, "constructor() moduleConfig=")

        this.name                    = "Dropbox"
        this.description             = "The Dropbox module enables seamless integration with Dropbox, allowing users to easily access, share, and manage files directly within the application, enhancing collaboration and file management efficiency."
        this.svgIcon                 = "isvg-dropbox-integration"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel               = "Integrations"
        this.settingsUrl             = "settings/integrations/dropbox"
        this.parentSection           = SettingsParentSection.INTEGRATIONS

        this._isEnabled             = false
        this.canDisable             = false

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }


    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
